/* eslint-disable no-restricted-properties */
import { aesDecrypt, encrypt as aesEncrypt } from 'fif-payments-encryption/app/common/common-codec';
import crypto from 'crypto';
import { runtimeConfig } from '@config';

const rsaCryptoLib = require('fif-payments-encryption/app/common/common-rsa-crypto-lib');

const publicKey = runtimeConfig.publicKey.replace(/\\n/g, '\n');

const RANDOM_KEY_LENGTH = 32;

export const randomKey = () => {
  const secureBytes = crypto.randomBytes(RANDOM_KEY_LENGTH);
  return secureBytes.toString('hex');
};

export const encrypData = (request, oldKey) => {
  const key = randomKey();
  sessionStorage.setItem(oldKey, JSON.stringify(key));
  if (!request.data || !request.data.payload) {
    return { payload: '', key };
  }
  const aux = aesEncrypt(key, JSON.stringify(request.data.payload));
  return {
    payload: aux,
    key,
  };
};

export const decrypData = (data, oldKey) => {
  const key = JSON.parse(sessionStorage.getItem(oldKey));
  sessionStorage.removeItem(oldKey);
  return aesDecrypt(key, data);
};

export const getEncryptedKey = (key) => rsaCryptoLib.encrypt(key, publicKey);
